// jshint module: true

// element.matches() polyfill
if (Element && Element.protoype && !Element.prototype.matches) {
  if (Element.prototype.webkitMatchesSelector) { // Chrome < 34, Safari < 7.1, iOS < 8, Android < 5
    Element.prototype.matches = Element.prototype.webkitMatchesSelector;
  } else if (Element.prototype.msMatchesSelector) { // IE 9 / IE 10 / IE 11 / IE Edge
    Element.prototype.matches = Element.prototype.msMatchesSelector;
  } else if (Element.prototype.mozMatchesSelector) { // FF < 34
    Element.prototype.matches = Element.prototype.mozMatchesSelector;
  } else {
    Element.prototype.matches = function(element, selector) {
      const matches = (element.document || element.ownerDocument).querySelectorAll(selector);
      let i = matches.length;

      while (--i >= 0 && matches.item(i) !== element) {
        //
      }

      return i > -1;
    }
  }
}



// WEBPACK FOOTER //
// ./bluemountain/assets/scripts/vendor/fabrique/polyfills/element-matches.js